import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import styles from './ComplexFilterWidget.module.css';
import {
  catalogRulesFieldData,
  getCurrentDateTimeString,
} from "./ComplexFilters";
import ReactSelect from "react-select";
import { reverseTransformToDesiredFormat } from "../../helper/widget";
import { Box, Button, Card, Chip, CircularProgress, FormControl, FormControlLabel, FormGroup, IconButton, ListItemIcon, MenuItem, Radio, RadioGroup, Stack, Tooltip, Typography } from "@mui/material";
import { Add, ArrowForwardIos, ErrorOutlineOutlined } from "@mui/icons-material";
import {Checkbox as MuiCheckBox} from '@mui/material'
import {Tooltip as MuiTooltip} from '@mui/material'
import ComplexFilters from "./subComponents/AndOrLogic/ComplexFilter";
import amazonLogo from '../../assets/svgs/amazon.svg'
import myntraLogo from '../../assets/svgs/myntra.svg'
import flipkartLogo from '../../assets/svgs/flipkart.svg'
import adyogiLogo from "../../assets/images/Adyogi_logoz.svg";
const ComplexFilterWidget = (props) => {
    
const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const [selectedFilter, setSelectedFilter] = useState('')
  const [validationErrors, setValidationErrors] = useState([]);
  const [metricsGroupCondition, setMetricsGroupCondition] = useState("AND");
  const [metricsGroupConditionContents, setMetricsGroupConditionContents] = useState([]);
  const [dimensionsSummary, setDimensionsSummary] = useState([]);
  const [topXSummary, setTopXSummary] = useState([]);
  const [comparisonPercentageSummary, setComparisonPercentageSummary] = useState([]);
  const [metricsSummary, setMetricsSummary] = useState([]);
  const [dimensionsGroupCondition, setDimensionsGroupCondition] = useState("AND");
  const [dimensionsGroupConditionContents, setDimensionsGroupConditionContents] = useState([
  ]);
  const [campaignGroupConditionContents, setCampaignGroupConditionContents] = useState([]);
  const [campaignsGroupCondition, setCampaignGroupCondition] = useState("AND");
  const [campaignsSummary, setCampaignSummary] = useState([]);

  const [isApplied, setIsApplied] = useState()
  const [isSidebar, setIsSidebar] = useState(false)
  const [topXFilter, setTopXFilter] = useState([]);
  const [showTopXFilter, setShowTopXFilter] = useState(false)
  const [comparisonPercentageFilter, setComparisonPercentageFilter] = useState([]);
  const [showComparisonPercentageFilter, setShowComparisonPercentageFilter] = useState(false)
  const [comparisonPercentageGroupCondition, setComparisonPercentageGroupCondition] = useState("AND")
  const[selectedDay, setSelectedDay]=useState(props?.selectedDay)
  const [showCampaignFilter, setShowCampaignFilter] = useState(false)
  const [showDimensionFilter, setShowDimensionFilter] = useState(true)
  const isInvalidColumnError = props?.config?.dimension?.fields?.some((data) => {
    return data?.isError && dimensionsGroupConditionContents?.some((content) => {
      return content?.data?.some((innerContent) => {
        return innerContent?.category === data?.id
      })
    })
  })
  const errorMessage = isInvalidColumnError ? props?.invalidColumnErrorMsg : props?.errorMessage


  const preFilterOperators = props?.filterOperators ? props?.filterOperators : []

   const PLATFORM_LOGOS = {
      amazon: amazonLogo,
      myntra: myntraLogo,
      flipkart: flipkartLogo,
      adyogi: adyogiLogo,
    };

  useEffect(()=> {
    setShowCampaignFilter(props?.campaignFilter)
    setShowDimensionFilter(props?.showDimensionFilter ?? true)
  },[props?.campaignFilter, props?.showDimensionFilter])
  useEffect(()=> {
    setIsSidebar(props?.sidebar ?? true)
  },[props?.sidebar])

  useEffect(()=>{
    setSelectedDay(props?.selectedDay)
     setIsApplied(false);
     props?.isAppliedCallback(false);
  },[props?.selectedDay])

  useEffect(()=> {
    if(props?.default) {
      setSelectedFilter(props?.default)
    }
    // setSelectedFilter(props?.default ?? 'metrics')  // this for selecting filters for the first time
  },[props?.default])

  // useEffect(()=> {
  //   document.getElementById('FilterBodySection').scrollIntoView({ behavior: 'smooth' });
  // },[selectedFilter])

  // Remove incomplete rows automatically when switching tabs / applying:
  // - if category and operator are selected but userInput is missing/empty
  // - if category/operator are missing too
  // For operators that don't need user input (Exist/Not Exist), we keep the row.
  const isConditionValuePresent = (condition) => {
    if (!condition) return false;
    if (condition?.filter === "Exist" || condition?.filter === "Not Exist") {
      return true;
    }

    const userInput = condition?.userInput;
    if (Array.isArray(userInput)) {
      if (userInput.length === 0) return false;
      const first = userInput?.[0];
      if (first === null || first === undefined) return false;
      if (typeof first === "string" && first.trim() === "") return false;
      return true; // keep values like "0", "-" etc.
    }

    if (userInput === null || userInput === undefined) return false;
    if (typeof userInput === "string") return userInput.trim() !== "";
    return true;
  };

  const autoPruneGroupConditionContents = (groupConditionContents) => {
    return (groupConditionContents ?? [])
      .map((group) => ({
        ...group,
        data: (group?.data ?? []).filter(
          (condition) =>
            Boolean(condition?.category) &&
            Boolean(condition?.filter) &&
            isConditionValuePresent(condition)
        ),
      }))
      .filter((group) => (group?.data ?? []).length > 0);
  };

  const handleGroupSelectionFilters = (typeName) => {
    if(selectedFilter==='') {
      setSelectedFilter(typeName)
      return
    }

    if(selectedFilter!=='') {
      // Auto-remove incomplete conditions from the current tab before validation.
      let nextMetrics = metricsGroupConditionContents;
      let nextDimensions = dimensionsGroupConditionContents;
      let nextCampaigns = campaignGroupConditionContents;
      let nextTopX = topXFilter;
      let nextComparisonPercentage = comparisonPercentageFilter;

      if (selectedFilter === "metrics") {
        nextMetrics = autoPruneGroupConditionContents(metricsGroupConditionContents);
        setMetricsGroupConditionContents(nextMetrics);
      } else if (selectedFilter === "dimensions") {
        nextDimensions = autoPruneGroupConditionContents(dimensionsGroupConditionContents);
        setDimensionsGroupConditionContents(nextDimensions);
      } else if (selectedFilter === "campaigns") {
        nextCampaigns = autoPruneGroupConditionContents(campaignGroupConditionContents);
        setCampaignGroupConditionContents(nextCampaigns);
      } else if (selectedFilter === "topX") {
        nextTopX = autoPruneGroupConditionContents(topXFilter);
        setTopXFilter(nextTopX);
      } else if (selectedFilter === "comparisonPercentage") {
        nextComparisonPercentage = autoPruneGroupConditionContents(comparisonPercentageFilter);
        setComparisonPercentageFilter(nextComparisonPercentage);
      }

      const errorMap = {
        metrics: validateConditions(nextMetrics, props.config.measure, 'measure'),
        dimensions: validateConditions(nextDimensions, props.config.dimension, 'dimension'),
        campaigns: validateConditions(nextCampaigns, props.config.campaigns, 'campaigns'),
        topX: validateConditions(nextTopX, props.config.topXConfig, 'topX'),
        ...(props?.showComparisonPercentageFilter
          ? {
              comparisonPercentage: validateConditions(
                nextComparisonPercentage,
                props.config.measure,
                "measure"
              ),
            }
          : {}),
      };
      
      const errors = errorMap[selectedFilter];
      if (errors.length > 0) {
  
        setValidationErrors(errors);
  
        if (errorMap[selectedFilter]?.length > 0) {
            return; // Stay on the current tab if it has errors
        }
      } else {
        setSelectedFilter(typeName)
        setValidationErrors([]);
      }

    }
  }
  const addGroupConditionContent = (groupType) => {
    const groupConditions = {
      metrics: setMetricsGroupConditionContents,
      dimensions: setDimensionsGroupConditionContents,
      campaigns: setCampaignGroupConditionContents,
      comparisonPercentage: setComparisonPercentageFilter,
    };
  
    if (groupConditions[groupType]) {
      groupConditions[groupType]((prevContents) => [
        ...prevContents,
        {
          id: getCurrentDateTimeString(),
          data: [
            {
              id: getCurrentDateTimeString(),
              category: "",
              filter: "",
              userInput: "",
            },
          ],
          operator: "AND",
        },
      ]);
    }
  
    setIsApplied(false);
    props?.isAppliedCallback(false);
  };

  const removeGroupConditionContent = (idToRemove, groupType) => {
    const groupSetters = {
      metrics: setMetricsGroupConditionContents,
      dimensions: setDimensionsGroupConditionContents,
      campaigns: setCampaignGroupConditionContents,
      topX: setTopXFilter,
      comparisonPercentage: setComparisonPercentageFilter,
    };
  
    const setGroupContents = groupSetters[groupType];
    if(topXFilter?.length === 1 && groupType === 'topX') {
      setShowTopXFilter(false)
    }
    if (setGroupContents) {
      setGroupContents((prevContents) =>
        prevContents.filter((content) => content.id !== idToRemove)
      );
      setIsApplied(false);
        props?.isAppliedCallback(false);
    }
  };

  const updateGroupConditionContent = (index, updatedData, toUpdate, groupType) => {
    const groupSetters = {
      metrics: setMetricsGroupConditionContents,
      dimensions: setDimensionsGroupConditionContents,
      campaigns: setCampaignGroupConditionContents,
      topX: setTopXFilter,
      comparisonPercentage: setComparisonPercentageFilter,
    };
  
    const setGroupContents = groupSetters[groupType];
  
    if (setGroupContents) {
      setGroupContents((prevContents) =>
        prevContents.map((content) => {
          if (content.id === index) {
            return {
              ...content,
              [toUpdate]: updatedData,
            };
          }
          return content;
        })
      );
    }
  };

  useEffect(()=> {
    if(showTopXFilter) {
      setTopXFilter((prevContents) => {
        if (prevContents.length === 0) {
          return [
            {
              id: getCurrentDateTimeString(),
              data: [
                {
                  id: getCurrentDateTimeString(),
                  category: "",
                  filter: "",
                  userInput: "",
                },
              ],
              operator: "AND",
            },
          ];
        } else {
          // If prevContents is not blank, return it unchanged
          return prevContents;
        }
      });

    } else {
      setTopXFilter([])
    }
  },[showTopXFilter])

  useEffect(()=> {
    if(showComparisonPercentageFilter) {
      setComparisonPercentageFilter((prevContents) => {
        if (prevContents.length === 0) {
          return [
            {
              id: getCurrentDateTimeString(),
              data: [
                {
                  id: getCurrentDateTimeString(),
                  category: "",
                  filter: "",
                  userInput: "",
                },
              ],
              operator: "AND",
            },
          ];
        } else {
          return prevContents;
        }
      });
    } else {
      setComparisonPercentageFilter([])
      setComparisonPercentageGroupCondition("AND")
    }
  },[showComparisonPercentageFilter])

  useEffect(() => {
    if (!props?.showComparisonPercentageFilter) {
      setShowComparisonPercentageFilter(false);
      setComparisonPercentageFilter([]);
    }
  }, [props?.showComparisonPercentageFilter]);

  //need to work on this
  useEffect(() => {
    let topXreversedData = []
    let comparisonPercentagereversedData = []
    let metricreversedData = []
    let dimensionreversedData = []
    let campaignReversedData = []

    if(props?.filters) {
      setMetricsSummary([])
      setDimensionsSummary([])
      setTopXSummary([])
      setComparisonPercentageSummary([])
      setCampaignSummary([])
      if(props?.filters?.metrics?.custom_output) {
        metricreversedData = reverseTransformToDesiredFormat(props.filters.metrics.custom_output, props.config.measure)
        if(metricreversedData.length > 0) {
          setMetricsGroupConditionContents(metricreversedData);
          setMetricsGroupCondition(props.filters.metrics.custom_output.type === "OR_RULE" ? "OR" : "AND");
        } else {
          setMetricsGroupConditionContents([])
        }
      } 

      if(props?.filters?.dimension?.custom_output) {  
        dimensionreversedData = reverseTransformToDesiredFormat(props.filters.dimension.custom_output, props.config.dimension)
        if(dimensionreversedData.length > 0) {
          setDimensionsGroupConditionContents(dimensionreversedData);
          setDimensionsGroupCondition(props.filters.dimension.custom_output.type === "OR_RULE" ? "OR" : "AND");
        } else {
          setDimensionsGroupConditionContents([])
        }
      }

      if(props?.filters?.campaigns?.custom_output) {
        campaignReversedData = reverseTransformToDesiredFormat(props.filters.campaigns.custom_output, props.config.campaigns);
        if(campaignReversedData.length > 0) {
          setCampaignGroupConditionContents(campaignReversedData);
          setCampaignGroupCondition(props.filters.campaigns.custom_output.type === "OR_RULE" ? "OR" : "AND");
        } else {
          setCampaignGroupConditionContents([])
        }
      }

      if(props?.filters?.topX?.custom_output) {  
        topXreversedData = reverseTransformToDesiredFormat(props.filters.topX.custom_output, props.config.topXConfig);
        
        if(topXreversedData.length > 0) {
          setShowTopXFilter(true)
          setTopXFilter(topXreversedData)
        }
      } else {
          setShowTopXFilter(false)
          setTopXFilter([])
      }

      if (props?.showComparisonPercentageFilter && props?.filters?.comparisonPercentage?.custom_output) {
        comparisonPercentagereversedData = reverseTransformToDesiredFormat(
          props.filters.comparisonPercentage.custom_output,
          props.config.measure
        );

        if (comparisonPercentagereversedData.length > 0) {
          setShowComparisonPercentageFilter(true);
          setComparisonPercentageFilter(comparisonPercentagereversedData);
          setComparisonPercentageGroupCondition(
            props.filters.comparisonPercentage.custom_output.type === "OR_RULE"
              ? "OR"
              : "AND"
          );
        }
      } else if (!props?.showComparisonPercentageFilter) {
        setShowComparisonPercentageFilter(false);
        setComparisonPercentageFilter([]);
        setComparisonPercentageGroupCondition("AND");
      }
    }
    if((topXreversedData.length > 0 || comparisonPercentagereversedData.length > 0 || metricreversedData.length > 0 || dimensionreversedData.length > 0 || campaignReversedData.length > 0 ) && isApplied === undefined && props?.summary === 'onApplied'){
        setIsApplied(true) 
        props?.isAppliedCallback(true)
    } else if(!(topXreversedData.length > 0 || comparisonPercentagereversedData.length > 0 || metricreversedData.length > 0 || dimensionreversedData.length > 0 || campaignReversedData.length > 0 ) && isApplied === true && props?.summary === 'onApplied') {
        setIsApplied(false) 
        props?.isAppliedCallback(false)
    }
  }, [props?.filters, props?.summary, props?.showComparisonPercentageFilter]);

const isFirstRender = useRef(true);

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return; // Skip effect on first render
  }

  let dimensionreversedData = [];

  if (props?.filters?.dimension?.custom_output) {
    dimensionreversedData = reverseTransformToDesiredFormat(
      props.filters.dimension.custom_output,
      props.config.dimension
    );

    if (dimensionreversedData.length > 0) {
      setDimensionsGroupConditionContents(dimensionreversedData);
      setDimensionsGroupCondition(
        props.filters.dimension.custom_output.type === "OR_RULE" ? "OR" : "AND"
      );
    } else {
      setDimensionsGroupConditionContents([]);
    }
  }

  if (props?.setLoading) {
    props.setLoading();
  }
}, [props?.config?.dimension?.fields]); // If the fields are changing from the then update the transformed group conditions as well.

  const checkIsEmptyAllSection = () => {
    if(dimensionsGroupConditionContents.length > 0 || metricsGroupConditionContents.length > 0 || topXFilter.length > 0 || comparisonPercentageFilter.length > 0 || campaignGroupConditionContents.length > 0 ) {
      return false
    } else {
      return true
    }
  }
  

  const validateConditions = (groupConditionContents, config, type) => {
    const errors = [];
    groupConditionContents.forEach((group, groupIndex) => {
      const groupError = {};
      group.data.forEach((condition, conditionIndex) => {
        const conditionErrors = [];
        if (!condition.category) {
          conditionErrors.push({ category: 'Category is required.' });
        }
        if (!condition.filter) {
          conditionErrors.push({ filter: 'Filter is required.' });
        }
        if(condition.filter === 'Not Equals' && type === 'dimension' && !props.checkValidationForAllOperators ) {
          
        } else if (condition.filter === 'Exist' || condition.filter === 'Not Exist') {

        } else if(condition.userInput.length > 0  && type === 'topX') {
          const userInputNum = Number(condition.userInput[0].trim());
          if(isNaN(userInputNum)) {
            conditionErrors.push({ userInput: 'Please enter a numeric value.' });
          } else if(userInputNum < 1 || userInputNum > 99) {
            conditionErrors.push({ userInput: 'Values from 1 to 99 are allowed.' });
          }
        } else {
          let filedValue = config.fields.filter((field) => field.name === condition.category || field.id === condition.category)?.[0]?.datatype ?? ''
          if(filedValue === 'int' && condition.userInput.length > 0 ) {
            const userInputNum = Number(condition?.userInput?.[0]);
            if(isNaN(userInputNum) || condition?.userInput?.[0]==='') {
              conditionErrors.push({ userInput: 'Please enter a numeric value.' });
            }
          } else if (condition.userInput.length === 0 ||   (typeof condition.userInput[0] === 'string' && condition.userInput[0].trim() === '' || condition.userInput[0] == null)) {
            
            conditionErrors.push({ userInput: 'User input is required.' });
          }
        }
        if (conditionErrors.length > 0) {
          groupError[condition.id] = conditionErrors;
        }
      });
      if (Object.keys(groupError).length > 0) {
        errors.push(groupError);
      }
    });
    return errors;
};
  const handleSave = async () => {
    // Auto-remove incomplete conditions before validation/output.
    const prunedMetrics = autoPruneGroupConditionContents(metricsGroupConditionContents);
    const prunedDimensions = autoPruneGroupConditionContents(dimensionsGroupConditionContents);
    const prunedCampaigns = autoPruneGroupConditionContents(campaignGroupConditionContents);
    const prunedTopX = autoPruneGroupConditionContents(topXFilter);
    const prunedComparisonPercentage = autoPruneGroupConditionContents(
      comparisonPercentageFilter
    );

    setMetricsGroupConditionContents(prunedMetrics);
    setDimensionsGroupConditionContents(prunedDimensions);
    setCampaignGroupConditionContents(prunedCampaigns);
    setTopXFilter(prunedTopX);
    setComparisonPercentageFilter(prunedComparisonPercentage);

    // Keep summary consistent for props.summaryOutput(filterSummary()).
    setMetricsSummary(
      formatSummaryToLines(prunedMetrics, metricsGroupCondition)
    );
    setDimensionsSummary(
      formatSummaryToLines(prunedDimensions, dimensionsGroupCondition)
    );
    setCampaignSummary(
      formatSummaryToLines(prunedCampaigns, campaignsGroupCondition)
    );
    setTopXSummary(formatSummaryToLines(prunedTopX, "AND"));
    setComparisonPercentageSummary(
      formatSummaryToLines(prunedComparisonPercentage, comparisonPercentageGroupCondition)
    );

    const errorMap = {
      metrics: validateConditions(prunedMetrics, props.config.measure, 'measure'),
      dimensions: validateConditions(prunedDimensions, props.config.dimension, 'dimension'),
      campaigns: validateConditions(prunedCampaigns, props.config.campaigns, 'campaigns'),
      topX: validateConditions(prunedTopX, props.config.topXConfig, 'topX'),
      ...(props?.showComparisonPercentageFilter
        ? {
            comparisonPercentage: validateConditions(
              prunedComparisonPercentage,
              props.config.measure,
              "measure"
            ),
          }
        : {}),
    };

    const allErrors = Object.values(errorMap).flat(); // Flatten all error arrays
    if (allErrors.length > 0) {
      document.getElementById('FilterBodySection').scrollIntoView({ behavior: 'smooth' });

      setValidationErrors(allErrors);

      if (errorMap[selectedFilter]?.length > 0) {
          return; // Stay on the current tab if it has errors
      }
      for (const [filter, errors] of Object.entries(errorMap)) {
          if (errors.length > 0 && filter !== 'topX' && filter !== 'comparisonPercentage') {
              setSelectedFilter(filter);
              break;
          }
      }
      return;
    } else {
      setValidationErrors([]);

      const metricsTransformedOutput = transformGroupCondition(prunedMetrics, metricsGroupCondition, props.config.measure,'measure');
      const metricsCustomOutput = { "type":metricsGroupCondition.toUpperCase()+"_RULE",[metricsGroupCondition.toLowerCase()]: metricsTransformedOutput };

      const dimensionsTransformedOutput = transformGroupCondition(prunedDimensions, dimensionsGroupCondition, props.config.dimension,'dimension');
      const dimensionsCustomOutput = {"type":dimensionsGroupCondition.toUpperCase()+"_RULE", [dimensionsGroupCondition.toLowerCase()]: dimensionsTransformedOutput };
      
      const topXTransformedOutput = transformGroupCondition(prunedTopX, "AND", props.config.topXConfig,'topX');
      const topXCustomOutput = {"type":"AND_RULE", ["and"]: topXTransformedOutput };

      const comparisonPercentageTransformedOutput = props?.showComparisonPercentageFilter
        ? transformGroupCondition(
            prunedComparisonPercentage,
            comparisonPercentageGroupCondition,
            props.config.measure,
            "comparisonPercentage"
          )
        : [];
      const comparisonPercentageCustomOutput = {
        type: `${comparisonPercentageGroupCondition.toUpperCase()}_RULE`,
        [comparisonPercentageGroupCondition.toLowerCase()]:
          comparisonPercentageTransformedOutput,
      };

      const campaignsTransformedOutput = transformGroupCondition(prunedCampaigns, campaignsGroupCondition, props.config.campaigns,'campaigns');
      const campaignsCustomOutput = { "type":campaignsGroupCondition.toUpperCase()+"_RULE",[campaignsGroupCondition.toLowerCase()]: campaignsTransformedOutput };

      let output = {
        metrics: {
          custom_output:metricsTransformedOutput.length ? metricsCustomOutput : [] ,
          operator:metricsGroupCondition,
          data:prunedMetrics
        },
        dimension: {
          custom_output:dimensionsTransformedOutput.length > 0 ? dimensionsCustomOutput : [],
          operator:dimensionsGroupCondition,
          data:prunedDimensions
        },
        campaigns: {
          custom_output:campaignsTransformedOutput.length > 0 ? campaignsCustomOutput : [],
          operator:campaignsGroupCondition,
          data:prunedCampaigns
        },
        topX: {
          custom_output:topXTransformedOutput.length > 0 ? topXCustomOutput : [],
          operator:'AND',
          data:prunedTopX
        },
        comparisonPercentage: {
          custom_output:
            comparisonPercentageTransformedOutput.length > 0
              ? comparisonPercentageCustomOutput
              : [],
          operator: comparisonPercentageGroupCondition,
          data: prunedComparisonPercentage,
        }
      }
      props.output(output)
      if(props?.summaryOutput) {
        props.summaryOutput(filterSummary())
      }
      setTimeout(() => {
        setIsApplied(true)
        props?.isAppliedCallback(true);
      }, 500);
    }
  };

  function transformGroupCondition(groupConditionContents,groupCondition,config, type) {
    const transformedGroupCondition = [];
    groupConditionContents.forEach((group) => {
      const conditions = (group.data || []).map((condition) => {
        const fieldConfig = config?.fields?.find(
          (field) => field.name === condition.category || field.id === condition.category
        );
        const operatorConfig = config?.operators[
          fieldConfig?.datatype
        ]?.find((field) => field.name === condition.filter);
        const conditionObject = {
          type: "RULE_ITEM",
          member: fieldConfig
            ? props.prefixMember + fieldConfig.id
            : condition.category,
          operator: operatorConfig ? operatorConfig.id : condition.filter,
          values: condition.userInput !== "" ? condition.userInput  : fieldConfig?.datatype === 'int' ? [0]: [""],
        };

        const innerKey = condition.filter.toLowerCase() === "or" ? "or" : "and";

        return conditionObject;
      });

      if (conditions.length > 0) {
        const outerKey = group.operator.toLowerCase();
        transformedGroupCondition.push({
          type: outerKey === "or" ? "OR_RULE" : "AND_RULE",
          [outerKey]: conditions
        });
      }

      if (group.data) {
        const subgroups = transformGroupCondition(
          group.data,
          group.operator,
          config,
          type
        );
        if (subgroups.length > 0) {
          transformedGroupCondition.push(...subgroups);
        }
      }
    });
    return transformedGroupCondition;
  }

  const handleClose = () => {
     props?.setShowPopupModal(false)
  };

  function formatSummaryToLines(data, groupCondition) {
    const lines = [];
    data.forEach((group, index) => {
        // Check if group has data
        if (group.data && group.data.length > 0) {
            const conditions = group.data.map(condition => {
                const userInput = condition?.userInput?.length > 0 ? `${condition.userInput.join(', ')}` : '';
                return `${condition.category} ${condition.filter} ${userInput}`;
            }).join(` ${group.operator} `); // Added spaces around the operator

            lines.push(`${conditions}`);
        }

        // Add group condition (AND/OR) between groups, except after the last one
        if (index < data.length - 1 && group.data.length > 0) {
            lines.push(groupCondition);
        }
    });

    return lines;
}

  useEffect(() => {
    setMetricsSummary(formatSummaryToLines(metricsGroupConditionContents, metricsGroupCondition))
    setDimensionsSummary(formatSummaryToLines(dimensionsGroupConditionContents, dimensionsGroupCondition))
    setCampaignSummary(formatSummaryToLines(campaignGroupConditionContents, campaignsGroupCondition))
    setTopXSummary(formatSummaryToLines(topXFilter, "AND"))
    setComparisonPercentageSummary(
      formatSummaryToLines(comparisonPercentageFilter, comparisonPercentageGroupCondition)
    )
  },[metricsGroupConditionContents, dimensionsGroupConditionContents,metricsGroupCondition, dimensionsGroupCondition, topXFilter, comparisonPercentageFilter, comparisonPercentageGroupCondition, campaignGroupConditionContents, campaignsGroupCondition])

 const callOutFunction = (callOutType) => {
  const callOutText =  props?.calloutTitle
            ? props?.calloutTitle
            : selectedFilter === "metrics"
            ? "Select your product metrics"
            : selectedFilter === "campaigns"
            ? `Select your campaign ${userPlatform} attributes`
            : "Select your product attributes"
  return (
    <div className={styles.callOutCardContainer} >
      <IconButton size="small" onClick={() => {
        addGroupConditionContent(callOutType)
      }}>
        <Add fontSize="small"></Add>
      </IconButton>
      <span onClick={() => {
        addGroupConditionContent(callOutType)
      }} className={styles.callOutBodyText} style={{display:'flex',alignItems:'center',gap:'4px'}}>{callOutText}</span>
    </div>
  );
};

  const StyledBadge = ({ children, isOperator, type }) => {
    // Return the span only if children exist
    return children ? (
      <Tooltip
        title={
          <div
            style={{
              maxWidth: "400px",
              textAlign: "center",
              wordBreak: "break-word",
            }}
          >
            {children}
          </div>
        }
        arrow
      >
        <div
          className={styles.lineClampAtTwo}
          style={{
            padding: isOperator ? "0px 10px" : "2px 10px",
            borderRadius: "10px",
            backgroundColor: "#FFF",
            fontWeight: isOperator ? "bold" : "normal",
            width: "fit-content",
            wordBreak: "break-all",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          {children}
        </div>
      </Tooltip>
    ) : null;
  };

  const renderSummarySection = (summary, type, title) => {
    if (summary.length === 0) return null;
  
    return (
      <div className={styles.sectionWrapper} style={{padding:'0px'}}>
        {isSidebar && <div style={{padding:'8px 12px',borderBottom:'1px solid #E0E0E0'}}> 
          <div className={styles.filterSummaryCardTitle}>
          {title}</div>
          </div>}

        <div className={styles.summaryContent} >
          {summary.flatMap((line, index) => {
            if (line.trim() === '') return null;
  
            const parts = line.split(/(\sAND|\sOR)/);
            return (
              <div key={index} className={styles.card} style={{ display: 'flex', gap: '6px', width: '100%',backgroundColor:'#fff' }}>
                {parts.map((part, partIndex) => {
                  const isOperator = part === 'AND' || part === 'OR';
                  return (
                    <StyledBadge key={`${index}-${partIndex}`} isOperator={isOperator} type={type}>
                      {part.trim()}
                    </StyledBadge>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  function capitalizeFirstLetter(string) {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
  
  const filterSummary = () => {
    return (
      <div className={styles.cardWrappers}>
        {renderSummarySection(metricsSummary, 'metrics', 'Metric Filters')}
        {renderSummarySection(dimensionsSummary, 'dimensions', 'Attribute Filter')}
        {renderSummarySection(campaignsSummary, 'campaigns', 'Campaign Filter')}
        {renderSummarySection(topXSummary, 'topX', 'Narrow Down Filter Summary')}
        {props?.showComparisonPercentageFilter &&
          renderSummarySection(
            comparisonPercentageSummary,
            "comparisonPercentage",
            "Comparison Percentage Filter Summary"
          )}
      </div>
    );
  };

  const noFilterTypeSelectedComponent = <>
        <div className={styles.noFilterTypeContainer}> 
            <img src={'/svg/NoSearchResult.svg'} alt="Indore"/>
            <span className={styles.noFilterTypeHeading}>No Filter type selected</span>
            <span className={styles.noFilterTypeSubText}>No filters applied yet.</span>
        </div>
  </>

useEffect(()=> {
  if(props?.isAppliedCallback && isApplied !== undefined && props?.summary === 'onApplied' && (!checkIsEmptyAllSection && props?.page !== 'feed-management')) {
    props?.isAppliedCallback(isApplied)
  }
},[isApplied])
useEffect(()=> {
  if(props?.isAppliedCallback && isApplied !== undefined && props?.summary === 'onApplied' && ( props?.page === 'feed-management')) {
    props?.isAppliedCallback(isApplied)
  }
},[isApplied])


const topXLabel = () => {
return (<div></div>)
}


const showSummary = (metricsGroupConditionContents.length > 0 ||
  dimensionsGroupConditionContents.length > 0 ||
  topXSummary.length > 0 ||
  comparisonPercentageSummary.length > 0 ||
  campaignGroupConditionContents.length > 0) && props.type === "page" &&
  !props?.hideFilterSummary &&  props.type === "page" &&
  props?.summary === "onApplied" &&
  !isApplied // For Showing summary styles

const htmlContent = (minHeightPx) => {
  const isCampaignFilterApplied = campaignGroupConditionContents?.length > 0 && !validateConditions(campaignGroupConditionContents, props.config.campaigns, 'campaigns')?.length
  const isMetricsFilterApplied = metricsGroupConditionContents?.length > 0  && !validateConditions(metricsGroupConditionContents, props.config.measure, 'measure')?.length 
  const isAttributesFilterApplied = dimensionsGroupConditionContents?.length > 0  && !validateConditions(dimensionsGroupConditionContents, props.config.dimension, 'dimension')?.length
  const groupByChipLabelAnd =  <Chip label={'AND'} sx={{fontSize:'12px'}} size='small' />
  const groupByChipLabelOR =  <Chip label={'OR'} sx={{fontSize:'12px'}} size='small' />

  const areAllGroupsEmpty = 
  metricsGroupConditionContents.length === 0 &&
  dimensionsGroupConditionContents.length === 0 &&
  topXSummary.length === 0 &&
  comparisonPercentageSummary.length === 0 &&
  campaignGroupConditionContents.length === 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div
        style={{
          display:
            props.type === "page" && props?.summary === "onApplied" && isApplied
              ? "none"
              : "flex",
          gap: "16px",
          padding: "8px",
        }}
      >
        {isSidebar && (
          <div
            className={styles.tabContent}
            style={{ minHeight: minHeightPx ? minHeightPx : "610px" }}
          >
            <div className={styles.tabWrapper}>
              <div className={styles.tabHeading}>
                <span className={styles.filtersHeadingText}>Filters</span>
              </div>
              <div>
                <MenuItem
                  sx={{ display: "flex", justifyContent: "space-between" }}
                  selected={selectedFilter === "metrics"}
                  onClick={() => {
                    handleGroupSelectionFilters("metrics");
                  }}
                >
                  <Box>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      <Typography
                        color={
                          selectedFilter === "metrics"
                            ? "#6148F6"
                            : "textPrimary"
                        }
                        sx={{
                          paddingTop: isMetricsFilterApplied ? "4px" : "0px",
                          fontSize: "13px",
                        }}
                        variant={"caption"}
                      >
                        Metric
                      </Typography>
                      <div>
                        {isMetricsFilterApplied && (
                          <Chip
                            label={
                              <Typography fontSize="10px" variant="subtitle2">
                                Applied
                              </Typography>
                            }
                            sx={{
                              backgroundColor: "#dde0e4",
                              color: "#1f2124",
                              height: "22px",
                              borderRadius: "12px",
                              padding: "0 6px",
                              "& .MuiChip-label": {
                                padding: 0,
                              },
                            }}
                          />
                        )}
                      </div>
                    </Box>

                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: "10px" }}
                    >
                      Revenue,Spends,Purchases,etc.
                    </Typography>
                  </Box>

                  <ListItemIcon
                    sx={{
                      justifyContent: "end",
                      visibility:
                        selectedFilter === "metrics" ? "visible" : "hidden",
                    }}
                  >
                    <ArrowForwardIos fontSize="12px"></ArrowForwardIos>
                  </ListItemIcon>
                </MenuItem>
              </div>
              {!!showDimensionFilter && <div>
                <MenuItem
                  sx={{ display: "flex", justifyContent: "space-between" }}
                  selected={selectedFilter === "dimensions"}
                  onClick={() => {
                    handleGroupSelectionFilters("dimensions");
                  }}
                >
                  <Box>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      <Typography
                        color={
                          selectedFilter === "dimensions"
                            ? "#6148F6"
                            : "textPrimary"
                        }
                        sx={{
                          paddingTop: isAttributesFilterApplied ? "4px" : "0px",
                          fontSize: "13px",
                        }}
                        variant={"caption"}
                      >
                        Attribute
                      </Typography>
                      <div>
                        {isAttributesFilterApplied && (
                          <Chip
                            label={
                              <Typography fontSize="10px" variant="subtitle2">
                                Applied
                              </Typography>
                            }
                            sx={{
                              backgroundColor: "#dde0e4",
                              color: "#1f2124",
                              height: "22px",
                              borderRadius: "12px",
                              padding: "0 6px",
                              "& .MuiChip-label": {
                                padding: 0,
                              },
                            }}
                          />
                        )}
                      </div>
                    </Box>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: "10px" }}
                    >
                      {props?.dimension?.description ?? "Names, Type, Status, etc."}
                    </Typography>
                  </Box>
                  <ListItemIcon
                    sx={{
                      justifyContent: "end",
                      visibility:
                        selectedFilter === "dimensions" ? "visible" : "hidden",
                    }}
                  >
                    <ArrowForwardIos fontSize="12px"></ArrowForwardIos>
                  </ListItemIcon>
                </MenuItem>
              </div>}
              {!!showCampaignFilter && <div>
                <MenuItem
                  sx={{ display: "flex", justifyContent: "space-between" }}
                  selected={selectedFilter === "campaigns"}
                  onClick={() => {
                    handleGroupSelectionFilters("campaigns");
                  }}
                >
                  <Box>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      <Typography
                        color={
                          selectedFilter === "campaign"
                            ? "#6148F6"
                            : "textPrimary"
                        }
                        variant={"caption"}
                        sx={{
                          paddingTop:
                            isCampaignFilterApplied &&
                            selectedFilter !== "campaigns"
                              ? "4px"
                              : "0px",
                          fontSize: "13px",
                        }}
                      >
                        Campaign
                      </Typography>
                      <div>
                        {isCampaignFilterApplied &&
                          selectedFilter !== "campaigns" && (
                            <Chip
                              label={
                                <Typography fontSize="10px" variant="subtitle2">
                                  Applied
                                </Typography>
                              }
                              sx={{
                                backgroundColor: "#dde0e4",
                                color: "#1f2124",
                                height: "22px",
                                borderRadius: "12px",
                                padding: "0 6px",
                                "& .MuiChip-label": {
                                  padding: 0,
                                },
                              }}
                            />
                          )}
                      </div>
                    </Box>

                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: "10px" }}
                    >
                      All Campaigns
                    </Typography>
                  </Box>
                  <ListItemIcon
                    sx={{
                      justifyContent: "end",
                      visibility:
                        selectedFilter === "campaigns" ? "visible" : "hidden",
                    }}
                  >
                    <ArrowForwardIos fontSize="12px"></ArrowForwardIos>
                  </ListItemIcon>
                </MenuItem>
                {selectedFilter === "campaigns" && (
                  <>
                    <MenuItem
                      sx={{ pl: 4 }} // left padding to show hierarchy
                      selected={selectedFilter === "campaigns"}
                      onClick={() => handleGroupSelectionFilters("campaigns")}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="LOGO"
                          src={PLATFORM_LOGOS[userPlatform]}
                          height={14}
                          width={14}
                          style={{ marginTop: "4px" }}
                        />
                        <Typography
                          variant={"caption"}
                          color={
                            selectedFilter === "campaigns"
                              ? "#6148F6"
                              : "textPrimary"
                          }
                          sx={{ paddingTop: "4px" }}
                        >
                          {capitalizeFirstLetter(userPlatform)}
                        </Typography>
                        <div>
                          {isCampaignFilterApplied && (
                            <Chip
                              label={
                                <Typography fontSize="10px" variant="subtitle2">
                                  Applied
                                </Typography>
                              }
                              sx={{
                                backgroundColor: "#dde0e4",
                                color: "#1f2124",
                                height: "22px",
                                borderRadius: "12px",
                                padding: "0 6px",
                                "& .MuiChip-label": {
                                  padding: 0,
                                },
                              }}
                            />
                          )}
                        </div>
                      </Box>
                    </MenuItem>
                  </>
                )}
              </div>}
            </div>
          </div>
        )}
        <div
          className={styles.filters}
          style={{
            border: selectedFilter === "" ? "1px solid #E0E0E0" : "none",
            borderRadius: "8px",
          }}
          id={"FilterBodySection"}
        >
          {selectedFilter === "metrics" ? (
            <div className={styles.filterWrapper} key={"metrics"}>
              {catalogRulesFieldData.map((data) => (
                <div key={data.title}>
                  {metricsGroupConditionContents.length > 0 ? (
                    <>
                      {metricsGroupConditionContents.map((value, index) => (
                        <>
                          <ComplexFilters
                            trackingSource={props?.trackingSource}
                            key={value.id}
                            id={value.id}
                            showGroupCondition={
                              index ===
                              metricsGroupConditionContents?.length - 1
                            }
                            data={value.data}
                            operator={value.operator}
                            updateGroupConditionContent={(
                              updatedValue,
                              toUpdate
                            ) => {
                              updateGroupConditionContent(
                                value.id,
                                updatedValue,
                                toUpdate,
                                "metrics"
                              );
                            }}
                            removeGroupConditionContent={() => {
                              removeGroupConditionContent(value.id, "metrics");
                            }}
                            groupConditionFunc={() => {
                              addGroupConditionContent("metrics");
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            showCloseButton={
                              metricsGroupConditionContents?.length === 1
                                ? false
                                : true
                            }
                            conditionError={validationErrors}
                            config={props.config.measure}
                            type={props.type}
                            userAction={(e) => {
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            multiple={true}
                            preFilterOperators={preFilterOperators}
                          />
                          {metricsGroupConditionContents.length > 1 &&
                            index <
                              metricsGroupConditionContents.length - 1 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {/* <Select style={{ height: '24px' }} options={filterOperators} value={metricsGroupCondition} onChange={(value) => { setMetricsGroupCondition(value); setIsApplied(false) }} /> */}
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={metricsGroupCondition}
                                    sx={{ display: "flex", flexWrap: "nowrap" }}
                                    onChange={(e) => {
                                      setMetricsGroupCondition(e.target.value);
                                      setIsApplied(false);
                                      props?.isAppliedCallback(false);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="AND"
                                      control={<Radio size="small" />}
                                      label={groupByChipLabelAnd}
                                    />
                                    <FormControlLabel
                                      value="OR"
                                      control={<Radio size="small" />}
                                      label={groupByChipLabelOR}
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            )}
                        </>
                      ))}
                    </>
                  ) : (
                    <div>{callOutFunction("metrics")}</div>
                  )}
                  {/* {metricsGroupConditionContents.length > 0 && !props?.hideGroupCondition ?
                    <div>
                      <div className={styles.groupCondition}>
                        <div onClick={() => { addGroupConditionContent('metrics'); setIsApplied(false) }} className={styles.Condition} style={{ cursor: "pointer" }}>
                          <img src="/catalog/circle plus.svg" alt="" />
                          <p>Group Condition</p>
                        </div>
                      </div>
                                          </div> : <div style={{marginTop:'25px'}}></div>} */}
                  {props?.showDays &&
                    props?.showDays == true &&
                    selectedFilter === "metrics" &&
                    metricsGroupConditionContents.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          paddingTop: "10px",
                          fontSize: "14px",
                        }}
                      >
                        <span>In the last</span>
                        <ReactSelect
                          className="basic-single"
                          isSearchable={true}
                          options={props.daysOptions}
                          value={selectedDay}
                          onChange={props?.handleSelectedDay}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "30px",
                              height: "30px",
                              borderColor: "#AEB4B9",
                              fontSize: "12px",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0px 6px", // less padding
                              height: "30px",
                            }),
                            input: (provided) => ({
                              ...provided,
                              margin: "0px",
                              padding: "0px",
                            }),
                            indicatorsContainer: (provided) => ({
                              ...provided,
                              height: "30px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "2px", // reduce arrow size padding
                            }),
                            clearIndicator: (provided) => ({
                              ...provided,
                              padding: "2px", // reduce X icon padding
                            }),
                            menuPortal: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              fontSize: "12px",
                              maxHeight: "120px",
                            }),
                          }}
                        />
                      </div>
                    )}
                </div>
              ))}
            </div>
          ) : selectedFilter === "dimensions" ? (
            <div className={styles.filterWrapper} key={"dimension"}>
              {catalogRulesFieldData.map((data) => (
                <div key={data.Featuretitle}>
                  {dimensionsGroupConditionContents.length > 0 ? (
                    <>
                      {dimensionsGroupConditionContents.map((value, index) => (
                        <>
                          <ComplexFilters
                            key={value.id}
                            id={value.id}
                            showGroupCondition={
                              dimensionsGroupConditionContents?.length - 1 ===
                              index
                            }
                            data={value.data}
                            isError={value?.isError ?? false}
                            operator={value.operator}
                            updateGroupConditionContent={(
                              updatedValue,
                              toUpdate
                            ) => {
                              updateGroupConditionContent(
                                value.id,
                                updatedValue,
                                toUpdate,
                                "dimensions"
                              );
                            }}
                            removeGroupConditionContent={() => {
                              removeGroupConditionContent(
                                value.id,
                                "dimensions"
                              );
                            }}
                            groupConditionFunc={() => {
                              addGroupConditionContent("dimensions");
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            showCloseButton={
                              dimensionsGroupConditionContents?.length === 1
                                ? false
                                : true
                            }
                            conditionError={validationErrors}
                            config={props.config.dimension}
                            type={props.type}
                            userAction={(e) => {
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            multiple={true}
                            inOperatorMaxValues={props.inOperatorMaxValues}
                            preFilterOperators={preFilterOperators}
                          />
                          {dimensionsGroupConditionContents.length > 1 &&
                            index <
                              dimensionsGroupConditionContents.length - 1 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="dimensions-row-radio-buttons-group"
                                    value={dimensionsGroupCondition}
                                    sx={{ display: "flex", flexWrap: "nowrap" }}
                                    onChange={(e) => {
                                      setDimensionsGroupCondition(e.target.value);
                                      setIsApplied(false);
                                      props?.isAppliedCallback(false);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="AND"
                                      control={<Radio />}
                                      label={groupByChipLabelAnd}
                                    />
                                    <FormControlLabel
                                      value="OR"
                                      control={<Radio />}
                                      label={groupByChipLabelOR}
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            )}
                        </>
                      ))}
                    </>
                  ) : (
                    <div>{callOutFunction("dimensions")}</div>
                  )}
                  {/* {dimensionsGroupConditionContents.length > 0 && !props?.hideGroupCondition  ?
                      <div>
                        <div className={styles.groupCondition}>
                          <div onClick={() => { addGroupConditionContent('dimensions'); setIsApplied(false) }} className={styles.Condition} style={{ cursor: "pointer" }}>
                            <img src="/catalog/circle plus.svg" alt="" />
                            <p>Group Condition</p>
                          </div>
                        </div>
                      </div>
                      : <div style={{marginTop:'25px'}}></div>} */}
                </div>
              ))}
              {(props?.isError || isInvalidColumnError) && (
                <div style={{ display: "flex", gap: "5px" }}>
                  {" "}
                  {
                    <img
                      title={null}
                      src={`/setupConnector/cards/redTriangle.svg`}
                      alt="csvIcon"
                    />
                  }
                  <span> {errorMessage}</span>
                </div>
              )}
            </div>
          ) : selectedFilter === "campaigns" ? (
            <div className={styles.filterWrapper} key={"campaigns"}>
              {catalogRulesFieldData.map((data) => (
                <div key={data.Featuretitle}>
                  {campaignGroupConditionContents.length > 0 ? (
                    <>
                      {campaignGroupConditionContents.map((value, index) => (
                        <>
                          <ComplexFilters
                            key={value.id}
                            id={value.id}
                            data={value.data}
                            showGroupCondition={
                              campaignGroupConditionContents?.length - 1 ===
                              index
                            }
                            operator={value.operator}
                            updateGroupConditionContent={(
                              updatedValue,
                              toUpdate
                            ) => {
                              updateGroupConditionContent(
                                value.id,
                                updatedValue,
                                toUpdate,
                                "campaigns"
                              );
                            }}
                            removeGroupConditionContent={() => {
                              removeGroupConditionContent(
                                value.id,
                                "campaigns"
                              );
                            }}
                            groupConditionFunc={() => {
                              addGroupConditionContent("campaigns");
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            showCloseButton={
                              campaignGroupConditionContents?.length === 1
                                ? false
                                : true
                            }
                            conditionError={validationErrors}
                            config={props.config.campaigns}
                            type={props.type}
                            userAction={(e) => {
                              setIsApplied(false);
                              props?.isAppliedCallback(false);
                            }}
                            multiple={true}
                            preFilterOperators={preFilterOperators}
                          />
                          {campaignGroupConditionContents.length > 1 &&
                            index <
                              campaignGroupConditionContents.length - 1 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="campaigns-row-radio-buttons-group"
                                    value={campaignsGroupCondition}
                                    sx={{ display: "flex", flexWrap: "nowrap" }}
                                    onChange={(e) => {
                                      setCampaignGroupCondition(e.target.value);
                                      setIsApplied(false);
                                      props?.isAppliedCallback(false);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="AND"
                                      control={<Radio />}
                                      label={groupByChipLabelAnd}
                                    />
                                    <FormControlLabel
                                      value="OR"
                                      control={<Radio />}
                                      label={groupByChipLabelOR}
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            )}
                        </>
                      ))}
                    </>
                  ) : (
                    <div>{callOutFunction("campaigns")}</div>
                  )}
                  {/* {campaignGroupConditionContents.length > 0 && !props?.hideGroupCondition  ?
                        <div>
                          <div className={styles.groupCondition}>
                            <div onClick={() => { addGroupConditionContent('campaigns'); setIsApplied(false) }} className={styles.Condition} style={{ cursor: "pointer" }}>
                              <img src="/catalog/circle plus.svg" alt="" />
                              <p>Group Condition</p>
                            </div>
                          </div>
                        </div>
                        : <div style={{marginTop:'25px'}}></div>} */}
                </div>
              ))}
            </div>
          ) : selectedFilter === "" ? (
            noFilterTypeSelectedComponent
          ) : null}

          {(metricsGroupConditionContents.length > 0 ||
            dimensionsGroupConditionContents.length > 0 ||
            topXSummary.length > 0 ||
            comparisonPercentageSummary.length > 0 ||
            campaignsSummary.length > 0) &&
          props.type === "popup" ? (
            <div className={styles.filterWrappers}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  padding: "12px",
                  width: "100%",
                }}
              >
                <div style={{ fontSize: "16px", fontWeight: "600" }}>
                  Applied Filter Summary
                </div>
                <div>
                  {dimensionsSummary.length > 0 ||
                  metricsSummary.length > 0 ||
                  topXSummary.length > 0 ||
                  comparisonPercentageSummary.length > 0 ||
                  campaignsSummary.length > 0
                    ? filterSummary()
                    : null}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {(metricsGroupConditionContents.length > 0 ||
        dimensionsGroupConditionContents.length > 0 ||
        topXSummary.length > 0 ||
        campaignGroupConditionContents.length > 0) &&
      props.type === "page" &&
      !props?.hideFilterSummary ? (
        <div
          className={styles.filterSummaryWrappers}
          style={{
            display:
              props.type === "page" &&
              props?.summary === "onApplied" &&
              !isApplied
                ? "none"
                : "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              // padding: "12px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#F5F5F5",
                padding: "8px",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <div className={styles.filterSummaryText}>
                {/* Applied Filter&apos;s */}
                Filter Summary
              </div>
              <Button
                size="small"
                sx={{
                  color: "#6148F6",
                  borderRadius: "8px",
                  padding: "4px 10px",
                  border: "1px solid rgba(97, 72, 246, 0.50)",
                }}
                variant="outlined"
                onClick={() => {
                  setIsApplied(false);
                  props?.isAppliedCallback(false);
                }}
              >
                Edit Filters
              </Button>
            </div>
            <div style={{ padding: "8px" }}>
              {dimensionsSummary.length > 0 ||
              metricsSummary.length > 0 ||
              topXSummary.length > 0 ||
              campaignsSummary.length > 0
                ? filterSummary()
                : null}
              {props?.showDays &&
                props?.showDays == true &&
                selectedFilter === "metrics" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      float: "right",
                      paddingTop: "16px",
                    }}
                  >
                    <span style={{ color: "#6d7175" }}>
                      * In the last {selectedDay.label}
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
      ) : null}
      {props?.narrowFilters && (
        <div style={{ padding: "0px 8px" }}>
          <Card
            sx={{
              padding: `${showTopXFilter ? "8px 16px" : "0px 16px"}`,
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
            }}
          >
            {props?.narrowFilters && (
              <FormGroup>
                <FormControlLabel
                  sx={{ width: "fit-content" }}
                  control={
                    <MuiCheckBox size="small" checked={showTopXFilter} />
                  }
                  onChange={(e) => {
                    setShowTopXFilter(e.target.checked);
                  }}
                  label={
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "2px",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          // className={styles.globalConditionText}
                          sx={{ fontSize: "13px" }}
                          color={"rgba(0, 0, 0, 0.87)"}
                          variant={"subtitle2"}
                        >
                          Apply Global Condition
                        </Typography>
                        <MuiTooltip
                          title={
                            "The selected percentage is applied to the total rows, and the resulting rows is rounded up to the nearest number."
                          }
                        >
                          <IconButton>
                            <ErrorOutlineOutlined
                              sx={{ height: 16, width: 16 }}
                              fontSize="small"
                            ></ErrorOutlineOutlined>
                          </IconButton>
                        </MuiTooltip>
                      </Box>
                    </>
                  }
                />
              </FormGroup>
            )}
            {props?.narrowFilters && (
              <div key={"top"}>
                {/* <div>
                      <Checkbox
                        label={topXLabel()}
                        checked={showTopXFilter}
                        onChange={(e) => setShowTopXFilter(e)}
                      />
                    </div> */}
                <div>
                  {showTopXFilter ? (
                    <div>
                      {topXFilter.map((value, index) => (
                        <ComplexFilters
                          key={value.id}
                          id={value.id}
                          data={value.data}
                          operator={value.operator}
                          updateGroupConditionContent={(
                            updatedValue,
                            toUpdate
                          ) => {
                            updateGroupConditionContent(
                              value.id,
                              updatedValue,
                              toUpdate,
                              "topX"
                            );
                          }}
                          removeGroupConditionContent={() => {
                            removeGroupConditionContent(value.id, "topX");
                          }}
                          showCloseButton={false}
                          conditionError={validationErrors}
                          config={props.config.topXConfig}
                          type={props.type}
                          userAction={(e) => {
                            setIsApplied(false);
                            props?.isAppliedCallback(false);
                          }}
                          multiple={true}
                          multipleLimit={2}
                          preFilterOperators={preFilterOperators}
                        />
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </Card>
          {props?.showComparisonPercentageFilter && (
            <Card
              sx={{
                padding: `${showComparisonPercentageFilter ? "8px 16px" : "0px 16px"}`,
                boxShadow: "none",
                border: "1px solid #E0E0E0",
                borderRadius: "8px",
                mt: 1,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  sx={{ width: "fit-content" }}
                  control={
                    <MuiCheckBox
                      size="small"
                      checked={showComparisonPercentageFilter}
                    />
                  }
                  onChange={(e) => {
                    setShowComparisonPercentageFilter(e.target.checked);
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        gap: "2px",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "13px" }}
                        color={"rgba(0, 0, 0, 0.87)"}
                        variant={"subtitle2"}
                      >
                        Apply Comparison Percentage Filter
                      </Typography>
                      <MuiTooltip
                        title={
                          "Filter rows based on percentage change between the selected comparison date ranges."
                        }
                      >
                        <IconButton>
                          <ErrorOutlineOutlined
                            sx={{ height: 16, width: 16 }}
                            fontSize="small"
                          ></ErrorOutlineOutlined>
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                  }
                />
              </FormGroup>
              {showComparisonPercentageFilter ? (
                <div>
                  {comparisonPercentageFilter.map((value, index) => (
                    <div key={value.id}>
                      <ComplexFilters
                        id={value.id}
                        data={value.data}
                        operator={value.operator}
                        showGroupCondition={
                          index === comparisonPercentageFilter.length - 1
                        }
                        updateGroupConditionContent={(updatedValue, toUpdate) => {
                          updateGroupConditionContent(
                            value.id,
                            updatedValue,
                            toUpdate,
                            "comparisonPercentage"
                          );
                        }}
                        removeGroupConditionContent={() => {
                          removeGroupConditionContent(
                            value.id,
                            "comparisonPercentage"
                          );
                        }}
                        groupConditionFunc={() => {
                          addGroupConditionContent("comparisonPercentage");
                          setIsApplied(false);
                          props?.isAppliedCallback(false);
                        }}
                        showCloseButton={
                          comparisonPercentageFilter.length === 1 ? false : true
                        }
                        conditionError={validationErrors}
                        config={props.config.measure}
                        type={props.type}
                        userAction={() => {
                          setIsApplied(false);
                          props?.isAppliedCallback(false);
                        }}
                        multiple={true}
                        preFilterOperators={preFilterOperators}
                      />
                      {comparisonPercentageFilter.length > 1 &&
                        index < comparisonPercentageFilter.length - 1 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="comparison-percentage-radio-group"
                                name="comparison-percentage-radio-group"
                                value={comparisonPercentageGroupCondition}
                                sx={{ display: "flex", flexWrap: "nowrap" }}
                                onChange={(e) => {
                                  setComparisonPercentageGroupCondition(
                                    e.target.value
                                  );
                                  setIsApplied(false);
                                  props?.isAppliedCallback(false);
                                }}
                              >
                                <FormControlLabel
                                  value="AND"
                                  control={<Radio size="small" />}
                                  label={groupByChipLabelAnd}
                                />
                                <FormControlLabel
                                  value="OR"
                                  control={<Radio size="small" />}
                                  label={groupByChipLabelOR}
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              ) : null}
            </Card>
          )}
        </div>
      )}
      {props.type !== "popup" ? (
        <>
          {props?.editDisabled && props?.editDisabled == true ? (
            <></>
          ) : props.type === "page" &&
            props?.summary === "onApplied" &&
            isApplied &&
            areAllGroupsEmpty ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                size="small"
                sx={{
                  color: "#6148F6",
                  borderRadius: "8px",
                  padding: "4px 10px",
                  border: "1px solid rgba(97, 72, 246, 0.50)",
                }}
                variant="outlined"
                onClick={() => {
                  handleClose();
                  setIsApplied(false);
                  props?.isAppliedCallback(false);
                }}
              >
                Edit Filters
              </Button>
            </div>
          ) : (
            <div
              className={styles.cancelApplyContainer}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Stack sx={{ padding: "4px 0px" }} direction={"row"} spacing={1}>
                {props?.hideCancel ? null : (
                  <Button
                    size="small"
                    sx={{
                      color: "#6148F6",
                      borderRadius: "8px",
                      border: "1px solid rgba(97, 72, 246, 0.50)",
                      textTransform: "none",
                    }}
                    variant="outlined"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  disabled={props.fetchingData || isApplied}
                  color="primary"
                  sx={{
                    backgroundColor: "#6148F6",
                    borderRadius: "8px",
                    textTransform: "none",
                  }}
                  variant="contained"
                  size="small"
                  disableElevation
                  onClick={() => {
                    handleSave();
                  }}
                >
                  {isApplied ? "Applied" : "Apply"}
                </Button>
              </Stack>
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}


  if(props.type === 'popup') {
    return (
        <Modal
        dialogClassName={styles.popupModal}
        centered={true}
        show={props?.showPopupModal}
        animation={true}
        scrollable={true}
      >
        <Modal.Body>{htmlContent("700px")}</Modal.Body>
        <Modal.Footer>
          <button
            className="secondary-active-btn"
            onClick={() => {
              props?.setShowPopupModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="primary-active-btn"
            onClick={() => {
              handleSave();
            }}
          >
            Apply
          </button>
        </Modal.Footer>
      </Modal>
    );
  } else {
    const externalSummaryStyles = !showSummary && props?.summaryStyles
    return (
      <div className={`${styles.pageContent} ${styles[props?.page]}`} style={externalSummaryStyles ? props?.summaryStyles : {}}>
     {props?.loading ? <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',padding:'10px 0px'}}><CircularProgress size={24}/></div> : htmlContent("auto")}   
      </div>
    );
  }
  
};
export default ComplexFilterWidget;